import { request } from './client';

/**
 * The pick planner.
 *
 * <p>No playerId in any of these paths. A plan is only ever your own, so the server takes
 * the actor from the session - there is no version of this screen that shows somebody
 * else's route, and an id in the URL would invite one.
 *
 * <p>Every call returns the <em>whole</em> planner, writes included. Planning one week
 * changes what is offered in the other four, so a client that had to re-fetch after a
 * write would paint a team as free for the length of the round trip.
 */
export function getPlanner(gameId) {
  return request(`/api/customer/games/${gameId}/planner`);
}

export function planPick(gameId, gameWeek, teamId) {
  return request(`/api/customer/games/${gameId}/planner/weeks/${gameWeek}`, {
    method: 'PUT',
    body: { teamId },
  });
}

export function clearPlannedPick(gameId, gameWeek) {
  return request(`/api/customer/games/${gameId}/planner/weeks/${gameWeek}`, {
    method: 'DELETE',
  });
}
